import { render, staticRenderFns } from "./DocumentStatus.vue?vue&type=template&id=cd0b2abe"
import script from "./DocumentStatus.vue?vue&type=script&lang=js"
export * from "./DocumentStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports